import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const DataGridToolbar = ({ 
  onSearch, 
  onAdd, 
  onBulkImport, 
  onExport, 
  selectedCount = 0,
  onBulkDelete,
  categoryLabel 
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchChange = (e) => {
    const value = e?.target?.value;
    setSearchQuery(value);
    onSearch(value);
  };

  return (
    <div className="bg-card border-b border-border px-6 py-4">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3 flex-1 min-w-[300px]">
          <div className="relative flex-1 max-w-md">
            <Input
              type="search"
              placeholder={`Search ${categoryLabel?.toLowerCase()}...`}
              value={searchQuery}
              onChange={handleSearchChange}
              className="pl-10"
            />
            <Icon 
              name="Search" 
              size={18} 
              className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
            />
          </div>
          
          {selectedCount > 0 && (
            <div className="flex items-center gap-2 px-3 py-2 bg-primary/10 text-primary rounded-md">
              <Icon name="CheckSquare" size={18} />
              <span className="text-sm font-medium">{selectedCount} selected</span>
              <Button
                variant="ghost"
                size="sm"
                iconName="Trash2"
                onClick={onBulkDelete}
                className="ml-2"
              >
                Delete
              </Button>
            </div>
          )}
        </div>

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="default"
            iconName="Upload"
            iconPosition="left"
            onClick={onBulkImport}
          >
            Bulk Import
          </Button>
          
          <Button
            variant="outline"
            size="default"
            iconName="Download"
            iconPosition="left"
            onClick={onExport}
          >
            Export
          </Button>
          
          <Button
            variant="default"
            size="default"
            iconName="Plus"
            iconPosition="left"
            onClick={onAdd}
          >
            Add {categoryLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DataGridToolbar;